<template>
 <v-fade-transition>
  <wgu-module-card v-bind="$attrs" :moduleName="moduleName" :icon="icon" class="card" width=50% height=70%>

      <v-card-text style="font-family: 'Open Sans';" class="specialFont onprimary--text">
        <p>
          Das Internetangebot wird bereitgestellt durch die
        </p>
        <h2>Stadtentwässerungsbetriebe Köln, AöR</h2>
        <p>
          Ostmerheimer Straße 555<br />
          51109 Köln<br />
          Telefon: 0221 221-26868<br />
          Telefax: 0221 221-26770<br />
          Email:<a href="mailto:steb@steb-koeln.de" target="_blank">steb@steb-koeln.de</a><br />
          Umsatzsteueridentifikationsnummer (UStID): DE224970939
        </p>

        <h2>Vorständin:</h2>
        <p>
          Dipl.-Ing. Ulrike Franzke
        </p>
      </v-card-text>

  </wgu-module-card>
 </v-fade-transition>
</template>

<script>
// the module card is a the template for a typical Wegue module
import ModuleCard from '../../../src/components/modulecore/ModuleCard';
import { useDisplay } from 'vuetify';

export default {
  name: 'wgu-impressum',
  components: {
    'wgu-module-card': ModuleCard
  },
  setup () {
    const { name } = useDisplay();
    const vueDisplayInfo = name.value;
    return { vueDisplayInfo };
  },
  created () {
  },
  props: {
    icon: { type: String, required: false, default: 'star' }
  },
  mounted () {
    // console.log(this.$parent.$el.offsetHeight);
  },
  // here we define variables that are used in the HTML above
  data () {
    return {
      moduleName: 'wgu-impressum'
    };
  },
  methods: {
    /**
     * This function is called once the map is bound to the application
     */
  }
};
</script>

<!-- Here we do the styling of our module -->
<style scoped>

.card {
  overflow: auto;
  left: 60% !important;
  right: 50% !important;
  top: 50% !important;
  transform: translate(-50%, -50%);  /* zentriert Fenster, bei kleinen Bildschirmen dann*/
  /*
  height: 90%;
  width: 90%;
  */
  max-width: 90%;
  max-height: 90%;
  min-width: 250px;
  min-height: 250px;
  z-index: 55 !important;

}

.v-card > :last-child {
  overflow: auto;
  height: calc(100% - 70px);
}

h1 {
  font-size: 1.4em;
  line-height: 2rem;
  margin-bottom: 10px;
  color: #00508c;
}

h2 {
  font-size: 1.2em;
  margin-top: 20px;
  margin-bottom: 6px;
  color: #00508c;
}

h3 {
  font-size: 1.1em;
  margin-bottom: 10px;
  color: #00508c;
}

p {
  font-size: 1em;
  line-height: 1.5rem;
}

a {
    color: #007bC7 !important;
}

ul {
  padding-left: 4%;
  padding-bottom: 10px;
}

</style>
